import R from 'ramda';
import tabletemplate from './table.tpl.html';

export class Table {
  $onInit() {
    this.search = {};
    this.sort = {};
    this.page = 1;
    this.limit = '10';
    this.paramList = {
      sort: this.sort,
      search: this.search,
    };
    this.reduceCombinedText = Table.reduceCombinedText;

    this.numPages =
      this.totNumItems ? Table.calcPages(this.totNumItems, parseInt(this.limit, 10)) : 1;
  }

  $onChanges(changesObj) {
    const newData = changesObj.data && changesObj.data.currentValue;
    const newColumns = changesObj.columns && changesObj.columns.currentValue;
    const enums = changesObj.enums && changesObj.enums.currentValue;
    const newTotNumItems = changesObj.totNumItems && changesObj.totNumItems.currentValue;
    this.data = newData || this.data;
    this.columns = newColumns || this.columns;
    this.enums = enums || this.enums;
    this.totNumItems = newTotNumItems || this.totNumItems;
    this.numPages =
      this.totNumItems ? Table.calcPages(this.totNumItems, parseInt(this.limit, 10)) : 1;
  }

  handleSearchClick() {
    const paramList = {
      search: this.mapSearchParams(),
      sort: this.mapSortParams(),
      limit: this.limit,
      page: this.page,
    };
    this.onSearch({ paramList });
  }

  toggleSort(column) {
    if (column.sortable) {
      switch (column.sort) {
        case 'asc':
          column.sort = '';
          break;
        case 'desc':
          column.sort = 'asc';
          break;
        default:
          column.sort = 'desc';
          break;
      }

      const paramList = {
        search: this.mapSearchParams(),
        sort: this.mapSortParams(),
      };
      this.onSearch({ paramList });
    }
  }

  getStatuses(statusesString) {
    const statusLens = R.lensPath(R.split('.', statusesString));
    return R.view(statusLens, this.enums);
  }

  static reduceCombinedText(col, el) {
    return R.reduce((acc, curVal) => `${acc}${el[curVal]} `, '', col.ids);
  }

  mapSearchParams() {
    return R.reduce(R.curry(Table.toKeyValue)('input'), {}, this.searchParams);
  }

  mapSortParams() {
    return R.reduce(R.curry(Table.toKeyValue)('sort'), {}, R.filter(column => column.sortable, this.columns));
  }

  static toKeyValue(prop, obj, el) {
    obj[el.id] = el[prop];
    return obj;
  }

  static calcPages(numItems, limit) {
    let numPages = Math.floor(numItems / limit);
    if (numItems % limit) {
      numPages += 1;
    }
    return numPages;
  }

  addRow() {
    const keys = Object.keys(this.data[0]);
    const newRow = R.reduce(R.curry(toRowObj)(this.data), {}, keys);

    this.data.push(newRow);

    function toRowObj(data, acc, key) {
      acc[key] = {
        id: key,
        value: '',
        type: 'field',
        field_name: data[0][key].field_name,
      };
      return acc;
    }
  }

  getEmptyListMessageKey() {
    return !R.isNil(this.emptyListMessageKey) && !R.isEmpty(this.emptyListMessageKey)
      ? this.emptyListMessageKey
      : 'TABLE_GENERIC_EMPTY_LIST';
  }

  inputChange() {
    this.onInput({ fields: this.data });
  }

  prevPage() {
    this.page -= 1;
    this.handleSearchClick();
  }

  nextPage() {
    this.page += 1;
    this.handleSearchClick();
  }

  changeLimit() {
    this.page = 1;
    this.handleSearchClick();
  }

  /* eslint-disable */
  getCellValue(column, element) {
    if (column.transform) {
      return column.transform(column, element);
    } else if (column.fields && Array.isArray(column.fields)) {
      return R.reduce((value, field) => `${value}${R.pathOr('', field.split('.'), element)} `, '', column.fields);
    }

    const value = R.pathOr('-', column.id.split('.'), element);
    return !R.isEmpty(value)
      ? value
      : '-';
  }

  getBooleanValue(column, element) {
    if (column.booleanKey) {
      if (typeof column.booleanKey === 'string') {
        return R.pathOr('', column.booleanKey.split('.'), element);
      } else if (typeof column.booleanKey === 'function') {
        return column.booleanKey(column, element);
      }
    }

    return false;
  }

  shouldBeWrapped(col) {
    return !col.attrs || (col.attrs && (typeof col.attrs.wrap === 'undefined' || col.attrs.wrap));
  }

  showElement(col, element) {
    return col.showElement
      ? col.showElement(element, col)
      : true;
  }
  /* eslint-enable */
}

export const tctTable = {
  template: tabletemplate,
  controller: Table,
  bindings: {
    columns: '<',
    data: '<',
    enums: '<',
    topClass: '<',
    totNumItems: '<',
    searchParams: '<',
    loading: '<',
    emptyListMessageKey: '<?',
    editable: '<',
    onSearch: '&',
    onInput: '&',
  },
};
